<section class="profile-section">
 
  <div class="profile-wrapper">
    <app-breadcrumb></app-breadcrumb>
    <!-- Profile Picture Upload -->
    <div class="profile-photo-center">
      <h3 class="profile-title">Profile Picture</h3>
 
      <div class="profile-preview">
        <img *ngIf="profileImageUrl" [src]="profileImageUrl" alt="Profile Picture" />
        <mat-icon *ngIf="!profileImageUrl">person</mat-icon>
      </div>
 
      <input
        type="file"
        (change)="onProfileImageSelected($event)"
        accept="image/*"
        hidden
        #profileInput
      />
 
      <div class="profile-actions">
        <button mat-stroked-button (click)="profileInput.click()">Upload Photo</button>
      </div>
 
      <div *ngIf="uploadingImage" class="w-100 mt-2">
        <mat-progress-bar mode="determinate" [value]="uploadProgress"></mat-progress-bar>
        <p class="text-muted mt-1 small">
          Uploading... {{ uploadProgress | number:'1.0-0' }}%
        </p>
      </div>
    </div>
 
    <!-- Profile Details Section -->
    <section class="edit-section mb-4">
      <div class="section-header" (click)="toggleSection('profile')">
        <h3><mat-icon class="me-1">person</mat-icon> Edit Profile</h3>
        <mat-icon class="section-toggle-icon">
          {{ expandedSection === 'profile' ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </mat-icon>
      </div>
 
      <div *ngIf="expandedSection === 'profile'" class="section-content">
        <form (ngSubmit)="saveProfile()" #profileForm="ngForm">
          <div class="form-grid d-grid gap-3 align-items-center">
 
            <!-- Full Name -->
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Full Name</mat-label>
              <input
                matInput
                [(ngModel)]="profileFormValues.name"
                name="name"
                required
                placeholder="John Doe"
              />
              <mat-icon matSuffix>person</mat-icon>
            </mat-form-field>
 
            <!-- Phone Number -->
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Phone Number</mat-label>
              <input
                matInput
                [(ngModel)]="profileFormValues.phoneNumber"
                name="phoneNumber"
                readonly
              />
              <mat-icon matSuffix>phone</mat-icon>
            </mat-form-field>
 
            <!-- Email -->
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Email</mat-label>
              <input
                matInput
                type="email"
                [(ngModel)]="profileFormValues.email"
                name="email"
                readonly
              />
              <mat-icon matSuffix>email</mat-icon>
            </mat-form-field>
 
          </div>
 
          <div class="section-actions mt-3">
            <button
              type="submit"
              mat-raised-button
              [disabled]="profileSaving || !profileForm.valid"
              class="save-btn"
            >
              <div class="btn-content d-flex align-items-center gap-2">
                <mat-spinner *ngIf="profileSaving" diameter="20"></mat-spinner>
                <mat-icon *ngIf="!profileSaving">save</mat-icon>
                <span>{{ profileSaving ? 'Saving...' : 'Save Profile' }}</span>
              </div>
            </button>
          </div>
        </form>
      </div>
    </section>
    <!-- Help Section (Navigation) -->
    <section class="edit-section mb-4">
      <div class="section-header" (click)="goToHelp()">
        <h3><mat-icon class="me-1">help_outline</mat-icon> Help</h3>
        <mat-icon>arrow_forward</mat-icon>
      </div>
    </section>
    <!--BookMark section  -->
    <section class="edit-section mb-4">
      <div class="section-header" (click)="goTobookmarks()">
        <h3><mat-icon class="me-1">bookmark</mat-icon> Bookmarks</h3>
        <mat-icon>arrow_forward</mat-icon>
      </div>
    </section>
    <!-- setting Section (Navigation) -->
    <section class="edit-section mb-4">
      <div class="section-header" (click)="goTosettings()">
        <h3><mat-icon class="me-1">settings</mat-icon> setting</h3>
        <mat-icon>arrow_forward</mat-icon>
      </div>
    </section>
    <!--log out section-->
    <section class="edit-section mb-4">
      <div class="section-header" (click)="logout()">
        <h3><mat-icon class="me-1">logout</mat-icon> logout</h3>
        <mat-icon>arrow_forward</mat-icon>
      </div>
    </section>
 
      </div>
 
 
</section>